<div>
    <!-- Only show MFA form when mfaType has been set (from login flow or loaded on this page) -->
    <ng-container *ngIf="global.mfaType">
    <!-- Step: Choose which MFA method to use only when both are enabled -->
    <ng-container *ngIf="mfaStep === 'select' && isBothMfa">
        <div class="form__heading-container" style="text-align: center">
            <ion-text class="form__heading mb-3">Choose verification method</ion-text>
            <ion-text style="text-transform: none">
                You have both phone and email verification enabled. Select how you would like to receive your code.
            </ion-text>
        </div>
        <div class="form__form-field mb-3 mt-3" style="display: flex; flex-direction: column; gap: 12px; align-items: stretch">
            <ion-button
                class="btn__primary form__btn"
                tappable
                expand="block"
                (click)="selectMfaMethod('phoneNumber')">
                Verify with Phone
            </ion-button>
            <ion-button
                class="btn__outline form__btn"
                tappable
                expand="block"
                fill="outline"
                (click)="selectMfaMethod('email')">
                Verify with Email
            </ion-button>
        </div>
    </ng-container>

    <!-- Step: Enter OTP for the chosen method -->
    <ng-container *ngIf="mfaStep === 'phoneNumber' || mfaStep === 'email'">
        <div class="form__heading-container" style="text-align: center">
        <ion-text class="form__heading mb-3">
            {{ mfaStep === 'phoneNumber' ? 'Complete phone Number MFA' : 'Complete Email MFA' }}
        </ion-text>
        <ion-text style="text-transform: none">
            We’ve sent a verification code to your
            {{ mfaStep === 'phoneNumber' ? 'phone number' : 'email' }}
            <span style="white-space: nowrap">{{ maskedContact }}</span
            >. Please check your
            {{ mfaStep === 'phoneNumber' ? 'messages' : 'inbox' }}
            to ensure you receive it. Enter the code below to complete the verification process.
        </ion-text>
        </div>

        <div class="form__form-field mb-3 mt-3" style="display: flex; justify-content: center; align-items: center">
            <ng-otp-input
                [config]="{length: length, allowNumbersOnly: true}"
                (onInputChange)="onOtpChange($event)"
                #ngOtpInput>
            </ng-otp-input>
        </div>

        <ion-button
            class="btn__primary form__btn mt-3"
            tappable
            id="loginBtn"
            expand="block"
            [disabled]="disableSubmit"
            (click)="onSubmit()">
            Verify
        </ion-button>
    </ng-container>
    </ng-container>
</div>
